import { reduce, keyBy, cloneDeep } from 'lodash';
import moment from 'moment';
import {
  MY_REP_FETCH_ALL_REPS,
  MY_REP_FETCH_MY_REPS,
  MY_REP_UPDATE_MY_REPS,
  MY_REP_FETCH_MANAGER_LIST,
} from './MyRepsActions';

// Initial State
const initialState = {
  allReps: {
    reps: [],
    status: null,
    errors: null,
  },
  myReps: {
    reps: [],
    status: null,
    errors: null,
  },
};

function populateMyRepsList(allReps, myRepsInfo) {
  const indexedInfo = keyBy(myRepsInfo, 'reps__id');
  return reduce(allReps, (items, rep) => {
    if (indexedInfo[rep._id]) {
      const info = indexedInfo[rep._id];
      items.push({
        ...(cloneDeep(rep)),
        start: info.start ? moment(info.start, 'YYYY-MM-DD') : null,
        end: info.end ? moment(info.end, 'YYYY-MM-DD') : null,
        is_lead: info.is_lead === true,
        is_owner: info.is_owner === true,
      });
    }
    return items;
  }, []);
}

function populateManagers(allReps, reps) {
  return reduce(allReps, (items, rep) => {
    items.push({
      ...rep,
      ...(reps[rep._id] ? { managers: reps[rep._id] } : { managers: [] }),
    });
    return items;
  }, []);
}

const MyRepsReducer = (state = initialState, action) => {
  switch (action.type) {
    case MY_REP_FETCH_ALL_REPS: {
      const {
        reps, status, errors,
      } = action;
      const { myReps } = state;
      return {
        ...state,
        allReps: {
          ...state.allReps,
          reps,
          status,
          errors,
        },
        myReps: {
          ...myReps,
          reps: populateMyRepsList(reps, myReps.reps),
        },
      };
    }
    case MY_REP_FETCH_MY_REPS: {
      const {
        reps, status, errors,
      } = action;
      const { allReps } = state;
      return {
        ...state,
        myReps: {
          ...state.allReps,
          reps: populateMyRepsList(allReps.reps, reps),
          status,
          errors,
        },
      };
    }
    case MY_REP_UPDATE_MY_REPS: {
      const {
        reps,
      } = action;
      const { allReps } = state;
      return {
        ...state,
        myReps: {
          ...state.myReps,
          reps: populateMyRepsList(allReps.reps, reps),
        },
      };
    }
    case MY_REP_FETCH_MANAGER_LIST: {
      const {
        reps,
      } = action;
      const { allReps } = state;
      return {
        ...state,
        allReps: {
          ...allReps,
          reps: populateManagers(allReps.reps, reps),
        },
      };
    }
    default:
      return state;
  }
};

/* Selectors */
export const getAllReps = state => state.myReps.allReps.reps;
export const getAllRepsLoading = state => state.myReps.allReps.status === 'loading';
export const getAllRepsLoaded = state => state.myReps.allReps.status === 'loaded';
export const getAllRepsHasErrors = state => state.myReps.allReps.status === 'error';
export const getAllRepsErrors = (state) => {
  if (state.myReps.allReps.status === 'error') {
    return state.myReps.allReps.errors;
  }
  return null;
};

export const getMyReps = state => state.myReps.myReps.reps;
export const getMyRepsLoading = state => state.myReps.myReps.status === 'loading';
export const getMyRepsLoaded = state => state.myReps.myReps.status === 'loaded';
export const getMyRepsHasErrors = state => state.myReps.myReps.status === 'error';
export const getMyRepsErrors = (state) => {
  if (state.myReps.myReps.status === 'error') {
    return state.myReps.myReps.errors;
  }
  return null;
};


// Export Reducer
export default MyRepsReducer;
